
export class ContractTermsAgencyModel {

  Id: number;
  IdRequest: number;
  RequestCode: string;
  ContractUrl: string;
  Status: string;
  NameAprovate: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  RequestNavigation: Request;
}
